
import { Component, Vue } from 'vue-property-decorator';
import AppLogo from '@/app/components/common/AppLogo.vue';
import { useAuthStore } from '@/app/store/authModule';

@Component({
  components: {
    AppLogo,
  },
})
export default class PublicTopNav extends Vue {
  private authStore = useAuthStore();

  gotoLogin() {
    if (this.$route.path !== '/login') {
      this.authStore.clearTokenUser();
      this.$router.push('/login');
    }
  }

  get hasRegistrationSession() {
    return this.authStore.hasRegistrationSession;
  }

  get isRegisterRoute() {
    let isRegisterRoute = false;
    ['/email-confirm', '/register', '/landing-register', '/approve'].forEach((path) => {
      if (this.$route.path.includes(path)) isRegisterRoute = true;
    });
    return isRegisterRoute;
  }
}
